import type {
  ZONE_NAME,
  ZONE_PROPERTY_NAME,
} from '@shared/types/enums/zone.enum';

export namespace ZoneHelpers {
  // eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
  export function getSharedZoneProperty<T>(propName: ZONE_PROPERTY_NAME): T {
    return Zone.current.get(propName);
  }

  // eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
  export function runInZone(
    zoneName: ZONE_NAME,
    fn: Function,
    properties: Partial<Record<ZONE_PROPERTY_NAME, unknown>> = {},
    baseZone?: Zone,
  ): Promise<any> {
    const zone = baseZone || Zone.current;
    const newZone = zone.fork({
      name: zoneName,
      properties,
    });

    return newZone.run(fn);
  }

  // eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
  export function runOutside(zoneProperty: ZONE_PROPERTY_NAME, fn: Function) {
    const zone = Zone.current.getZoneWith(zoneProperty);

    if (zone) {
      return zone.parent.run(fn);
    }

    return fn();
  }
}
